import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: '100%',
    borderColor: '#687C90',
    borderWidth: 2,
    borderRadius: 25,
    position: 'relative'
  },
  header: {
    fontWeight: 'bold',
    color: '#FFFFFF',
    marginBottom: '3%',
    marginLeft: 10
  },
  cardsContainer: {
    flex: 1
  },
  cartContainer: {
    borderRadius: 15,
    padding: 15,
    marginBottom: 20,
    borderColor: '#687C90',
    borderWidth: 2,
    position: 'relative',
    zIndex: 1
  },
  cartHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 15,
    flexWrap: 'wrap',
    paddingHorizontal: 15
  },
  cartTitle: {
    fontFamily: 'Poppins_600SemiBold',
    fontWeight: 'bold',
    color: '#FFFFFF',
    flex: 1,
    textAlign: 'center'
  },
  printButton: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 8,
    borderRadius: 5
  },
  printButtonText: {
    fontFamily: 'Poppins_300Light',
    color: '#FFFFFF',
    marginLeft: 5
  },

  headerRow: {
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    marginBottom: 20,
    paddingHorizontal: 10
  },
  rowIdColumn: {
    width: '13%',
    alignItems: 'center'
  },
  rowIdColumnResponsive: {
    overflow: 'visible',
    minWidth: 150,
    flexShrink: 0
  },
  rowControlsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%'
  },
  orderInfoColumn: {
    width: '58%'
  },
  orderInfoColumnResponsive: {
    flex: 1,
    minWidth: 0
  },
  totesRowColumn: {
    width: '7%',
    alignItems: 'center',
    justifyContent: 'center'
  },
  totesRowColumnResponsive: {
    minWidth: 60,
    flexShrink: 0
  },
  dimensionsColumn: {
    width: '20%',
    alignItems: 'center'
  },
  dimensionsColumnResponsive: {
    minWidth: 200,
    flexShrink: 0
  },
  buttonFlexShrink: {
    marginLeft: 8,
    flexShrink: 0
  },
  inputFlexible: {
    flex: 1,
    minWidth: 0
  },
  rowContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
    width: '100%',
    paddingHorizontal: 10
  },

  deleteButton: {
    width: 30,
    alignItems: 'center',
    justifyContent: 'center'
  },

  rowInput: {
    backgroundColor: '#FFFFFF',
    minWidth: 80,
    height: 40,
    borderRadius: 5,
    textAlign: 'center',
    fontSize: 16,
    marginLeft: 5
  },

  toteListContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    flexWrap: 'wrap',
    width: '100%'
  },
  tote: {
    height: 40,
    marginRight: 10,
    marginBottom: 5,
    borderRadius: 5,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: '#FFFFFF'
  },
  toteText: {
    fontFamily: 'Poppins_600SemiBold',
    color: '#FFFFFF'
  },

  toteCountContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%'
  },
  toteCountInput: {
    backgroundColor: '#FFFFFF',
    width: 35,
    height: 40,
    borderRadius: 5,
    textAlign: 'center',
    fontSize: 16
  },
  countButton: {
    padding: 2,
    alignItems: 'center',
    justifyContent: 'center'
  },

  dimensionsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'center'
  },
  dimensionCountContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginHorizontal: 5
  },
  dimensionCountInput: {
    backgroundColor: '#FFFFFF',
    width: 40,
    height: 40,
    borderRadius: 5,
    textAlign: 'center',
    fontSize: 16
  },
  dimensionLabelContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  },
  dimensionLabel: {
    fontFamily: 'Poppins_300Light',
    color: '#FFFFFF',
    fontSize: 12,
    marginBottom: 3,
    textAlign: 'center',
    width: 40
  },

  addRowButton: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 5,
    borderRadius: 5,
    marginTop: 10,
    borderWidth: 1,
    borderColor: '#FFFFFF',
    marginHorizontal: 'auto',
    justifyContent: 'center'
  },
  addRowText: {
    fontFamily: 'Poppins_300Light',
    color: '#FFFFFF',
    marginLeft: 5
  },
  addCartButton: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 5,
    borderRadius: 5,
    alignSelf: 'center',
    marginTop: 20,
    borderWidth: 1,
    borderColor: '#FFFFFF'
  },
  addCartText: {
    fontFamily: 'Poppins_300Light',
    color: '#FFFFFF',
    marginLeft: 5
  },

  headerText: {
    fontFamily: 'Poppins_300Light',
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: '500'
  },
  infoContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 10,
    borderRadius: 5,
    marginBottom: 15,
    flexWrap: 'wrap',
    position: 'relative',
    zIndex: 2
  },
  headerLeft: {
    fontFamily: 'Poppins_300Light',
    marginLeft: 45
  },
  headerRight: {
    fontFamily: 'Poppins_300Light',
    marginRight: 20
  },
  cartFooter: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 10,
    paddingHorizontal: 10
  },
  zoneAccessButton: {
    cursor: 'pointer',
    marginLeft: 20
  },
  zoneAccessText: {
    color: '#FFD700',
    fontSize: 14,
    fontWeight: '600'
  },
  zonePreferenceContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    marginTop: 20,
    paddingHorizontal: 10,
    paddingVertical: 10
  },
  zonePreferenceLabel: {
    fontFamily: 'Poppins_600SemiBold',
    color: 'white',
    fontSize: 20
  },
  zonePreferenceControls: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10
  },
  zonePreferenceButton: {
    borderWidth: 1,
    borderColor: '#FFFFFF',
    borderRadius: 5,
    paddingVertical: 6,
    paddingHorizontal: 12,
    minWidth: 100,
    alignItems: 'center',
    justifyContent: 'center'
  },
  zonePreferenceButtonText: {
    fontFamily: 'Poppins_300Light',
    color: '#FFFFFF',
    fontSize: 14
  },
  zonePreferenceTooltipButton: {
    padding: 5,
    cursor: 'pointer'
  },
  zonePreferenceInfoIcon: {
    fontSize: 20,
    color: '#ffff',
    cursor: 'pointer'
  },
  zonePreferenceTooltipModalOverlay: {
    flex: 1,
    backgroundColor: 'transparent'
  },
  zonePreferenceTooltipContainer: {
    borderRadius: 5,
    alignSelf: 'flex-start',
    zIndex: 99,
    elevation: 5
  },
  zonePreferenceTooltipText: {
    color: '#000000',
    fontSize: 12,
    lineHeight: 18
  },
  zonePreferenceTooltipArrow: {
    position: 'absolute',
    width: 0,
    height: 0,
    borderLeftWidth: 10,
    borderLeftColor: 'transparent',
    borderRightWidth: 10,
    borderRightColor: 'transparent',
    borderBottomWidth: 10,
    borderBottomColor: '#8a9daf'
  },

  scanPackToggleContainer: {
    display: 'flex',
    gap: 7,
    zIndex: -1,
    marginTop: 10
  },
  scanPackToggleContainerDesktop: {
    paddingLeft: 20
  },
  scanPackToggleContainerMobile: {
    paddingLeft: 10
  },
  scanPackToggleRow: {
    display: 'flex',
    gap: '15px',
    alignItems: 'center',
    flexDirection: 'row',
    position: 'relative'
  },
  scanPackToggleInfoButton: {
    width: 20
  },
  scanPackToggleLabel: {
    color: 'white',
    fontSize: '16px',
    fontWeight: 300,
    zIndex: 1000
  },
  scanPackTooltip: {
    zIndex: 1000
  }
});
